// extracted by mini-css-extract-plugin
export default {"hint_box":"OrderActionHint_hint_box__-FZ5v","without_border":"OrderActionHint_without_border__MU0IO","hint_text":"OrderActionHint_hint_text__+s0gy"};